<div class="ui-g-12" >
  <input *ngIf="selectedCouponValidity.param_functional_code == 'NUMERIC'" type="number" min="0" oninput="validity.valid||(value='');" pInputText [(ngModel)]="selectedCouponValidityValue"
  (input)="insertValue()"
  >
  <form *ngIf="formData && selectedCouponValidity.param_functional_code == 'DATE'" [formGroup]="formData">
    <app-kv-calendar 
      [inputName]="'couponDate'"
      [formData]="formData"
      [minDate]="minFruitionDate"
      [maxDate]="maxFruitionDate"
      [defaultDate]="formData.get('couponDate').value" 
      [defaultValue]="setCouponValidityDate()"
      [disabled]="!minFruitionDate || !maxFruitionDate"
      >
    </app-kv-calendar>
  </form>
  <p-dropdown *ngIf="selectedCouponValidity.param_functional_code == 'WEEK'" [options]="week"
    [(ngModel)]="selectedCouponValidityValue" field="label" (onChange)="insertValue()">
  </p-dropdown>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-fruition-setup/coupon-validity/coupon-validity.component.html